import axios, { AxiosRequestConfig } from 'axios';
import { AiNuxRequest, AiNuxResponse, AiStatus } from '../types/ai';
import { DataResponse } from '../types/api';

const URL = '/v2/ai';

class AiService {
  static generateNux(
    data: AiNuxRequest,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AiNuxResponse>> {
    return axios.post(`${URL}/nux`, data, config);
  }

  static getStatus(config?: AxiosRequestConfig): Promise<DataResponse<AiStatus>> {
    return axios.get(`${URL}/status`, config);
  }
}

export { AiService };
